const CustomLoader =()=>{
    return(
        <>
            <span className="loader"></span>
        </>
    )
}
export default CustomLoader